import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SELLER } from './sellerInfo';
import { resetCookieConsent } from '../../legal/cookieConsent';
import { setSeoMeta, toAbsoluteUrl } from '../../utils/seo';

export default function Cookies() {
  const s = SELLER;

  useEffect(() => {
    const canonical = toAbsoluteUrl('/cookies');
    setSeoMeta({
      title: `Политика cookie — ${s.brand}`,
      description: `Как ${s.brand} использует необходимые и аналитические cookie, включая Яндекс.Метрику.`,
      canonical,
      og: {
        type: 'website',
        title: `Cookie — ${s.brand}`,
        description: 'Необходимые cookie и аналитика Яндекс.Метрики по согласию.',
        url: canonical,
      },
    });
  }, [s.brand]);

  const changeChoice = () => {
    resetCookieConsent();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="container page" style={{ textAlign: 'left' }}>
      <h1>Политика использования cookie</h1>
      <p>
        Сайт {s.site} использует файлы cookie и сходные технологии. Обработка персональных данных
        описана в <Link to="/privacy">политике конфиденциальности</Link>.
      </p>

      <section>
        <h2>1. Необходимые cookie</h2>
        <p>
          Нужны для работы корзины и избранного, входа в аккаунт, безопасности сессии и защиты от
          злоупотреблений (в том числе CSRF). Без них сайт работает некорректно. Правовое основание —
          исполнение договора и законный интерес Оператора.
        </p>
      </section>

      <section>
        <h2>2. Аналитические cookie</h2>
        <p>
          Яндекс.Метрика (ООО «Яндекс», РФ): статистика посещений, карта кликов и, при включении в
          настройках счётчика, вебвизор. Загружается только после выбора «Принять все» в баннере
          cookie. Правовое основание — согласие.
        </p>
      </section>

      <section>
        <h2>3. Рекламные cookie сторонних сетей</h2>
        <p>
          Пиксели рекламных сетей (VK, Google Ads и т.п.) на Сайте не используются. Если появятся —
          будет запрошено отдельное согласие, а эта страница будет обновлена.
        </p>
      </section>

      <section>
        <h2>4. Управление</h2>
        <p>
          При первом визите показывается баннер: «Принять все» или «Только необходимые». Выбор
          хранится в браузере. Изменить решение:
        </p>
        <p>
          <button type="button" className="legal-btn" onClick={changeChoice}>
            Изменить выбор cookie
          </button>
        </p>
        <p>
          Также можно очистить данные сайта для {s.site.replace(/^https:\/\//, '')} в настройках
          браузера. Ограничение cookie в браузере может сломать корзину и вход.
        </p>
      </section>

      <section>
        <h2>5. Контакты</h2>
        <p>
          Вопросы: <a href={`mailto:${s.email}`}>{s.email}</a>,{' '}
          <Link to="/contacts">контакты</Link>.
        </p>
      </section>

      <p style={{ opacity: 0.8, marginTop: 24 }}>
        © {new Date().getFullYear()} {s.name}. Последнее обновление: {s.updatedAt}
      </p>
      <style>{`
        .legal-btn {
          background: #0f141a;
          color: #fff;
          border: 0;
          border-radius: 8px;
          padding: 9px 16px;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
        }
        .legal-btn:hover { background: #1e293b; }
        .legal-btn:focus-visible { outline: 2px solid #2563eb; outline-offset: 2px; }
      `}</style>
    </div>
  );
}
